export async function awaitTask(url, options = {}, pingInterval = 5000) {
  const response = await fetch(url, options);

  let data;
  const text = await response.text();
  try {
    data = JSON.parse(text);
  } catch (e) {
    console.error('Initial response for awaitTask was not valid json', { url, text });
    throw e;
  }

  const taskId = data.task_id;

  const result = await new Promise(async (resolve, reject) => {
    let interval;

    const checkStatus = async () => {
      const response = await fetch(`/api/v1/tasks/${taskId}/`, {
        method: 'GET',
        headers: options.headers,
      });
      const data = await response.json();

      if (data.task?.status === 'failed') {
        clearInterval(interval);
        reject(data);
        return;
      }

      if (data.task?.status === 'complete') {
        clearInterval(interval);
        resolve(data);
        return;
      }
    };

    // Call immediately to check the status
    await checkStatus();

    interval = setInterval(checkStatus, pingInterval);
  });

  return result;
}
